function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 212 283.5"
}, props), /*#__PURE__*/React.createElement("title", null, "VF_sign_in_rgb"), /*#__PURE__*/React.createElement("path", {
  d: "M138.6 99l-28.8 28.8H212v28H109.8l28.8 28.8-19.8 19.6-62.3-62.3 62.3-62.3L138.6 99z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v283.5h184v-99h-28v70.6H28.4V28.4l127.6.1v71h28V0z"
})));